import { BiSearch } from "react-icons/bi";

export default function LeaveTableSearch({
  searchQuery,
  setSearchQuery,
  handleSearchChange,
}) {
  return (
    <div className="p-4 flex justify-between items-center gap-4 flex-wrap">
      <div className="relative flex-1 min-w-[250px] max-w-xs">
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full px-4 py-2.5 rounded-full border border-gray-300 text-sm focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all"
        />

        <BiSearch className="absolute top-3 right-4 text-2xl text-gray-400" />
      </div>

      {searchQuery && (
        <button
          onClick={() => setSearchQuery("")}
          className="px-5 py-2.5 rounded-lg text-green-500 bg-white border border-green-500 text-sm font-medium hover:bg-green-500 hover:text-white transition-colors"
        >
          Clear Search
        </button>
      )}
    </div>
  );
}